<template>
  <div>

    <div class="wrap">
      <div class="content">
        <FullCalendar ref="fullCalendar" :options="calendarOptions">
          <template v-slot:eventContent='arg'>
            <div class="card w-100 h-100"
              :style="{ 'background-color': arg.event.extendedProps.book.colorObj ? arg.event.extendedProps.book.colorObj.hex : '#fff' }">
              <div class="card-body text-start p-1">
                <div class="row no-gutters">
                  <div class="col" style="font-size: 14px">
                    <b>{{ arg.event.title }}</b>
                    <br>
                    <!-- <br v-if="type !== 'resourceTimeGridDay'">
                    <span v-if="type === 'resourceTimeGridDay'"> - </span> -->
                    <div><b>{{ arg.event.extendedProps.book.sku }}</b> by {{ arg.event.extendedProps.book.staff }}</div>
                    <div>{{ arg.event.extendedProps.book.member }} - <u><a :href="'tel:' + arg.event.extendedProps.book.mobile" style="color:#fff">{{ arg.event.extendedProps.book.mobile }}</a></u></div>
                    <div>{{ arg.event.extendedProps.book.remarks }}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </FullCalendar>
      </div>
      <!-- <div class="panel-tag mt-3 col-sm-6 col-md-6 col-lg-6 h-50" v-if=" totalEntries == 0">
      {{ $t("table.no_records") }}
    </div> -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import FullCalendar from "@fullcalendar/vue";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import dayGridPlugin from "@fullcalendar/daygrid";
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import scrollgridPlugin from '@fullcalendar/scrollgrid';
import interactionPlugin from "@fullcalendar/interaction";
import { handleSessionExpired } from "../../../../assets/js/dashboard/dashboard";
import jQuery from 'jquery'

export default {
  name: "Calendar",
  components: {
    FullCalendar,
  },
  props: {
    selectedOutlet: {
      type: Object,
      default(rawProps) {
        return {}
      },
    },
    selectedStaff: {
      type: Object,
      default(rawProps) {
        return {}
      },
    },
    apptHours: {
      type: Array,
      default(rawProps) {
        return {}
      },
    },
  },
  data: function () {
    let now = moment();
    return {
      staffs: [],

      type: 'dayGridMonth',
      view: 'month',
      calendarOptions: {
        schedulerLicenseKey: '0893777896-fcs-1689307219',
        // plugins: [dayGridPlugin, interactionPlugin, resourceTimeGridPlugin],
        plugins: [dayGridPlugin, interactionPlugin, resourceTimeGridPlugin, scrollgridPlugin],
        // plugins: [dayGridPlugin, interactionPlugin, resourceTimelinePlugin],
        // plugins: [dayGridPlugin, interactionPlugin],
        defaultDate: now.startOf('week'),
        initialView: "resourceTimeGridDay",
        events: [],
        // height: '88vh',
        // contentHeight: '88vh',
        height: 'auto',
        contentHeight: 'auto',
        // dayMinWidth: 500,
        headerToolbar: {
          left: 'prev,next',
          center: 'title',
          // right: 'dayGridMonth,dayGridWeek,resourceTimeGridDay'
          right: 'resourceTimeGridDay,dayGridWeek,dayGridMonth'
          // right: 'dayGridMonth,dayGridWeek,resourceTimeline'
          // right: 'dayGridMonth,dayGridWeek,dayGridDay' // user can switch between the two
        },
        // businessHours: [],
        allDaySlot: false,
        slotEventOverlap: false,
        firstDay: 1,
        // titleFormat: 'dddd, MMMM D, YYYY',
        dayHeaderFormat: (args) => {
          if (this.type === 'dayGridMonth') {
            return moment(args.date).format('ddd')
          } else {
            return moment(args.date).format('ddd D/M')
          }
        },
        validRange: (info) => {
          let start = moment().startOf('month')
          let end = moment().endOf('month')
          return {
            start: start,
            end: end
          }
        },
        // selectConstraint: {
        //     start: moment().startOf('month').format('YYYY-MM-DD'),
        //     end: moment().endOf('month').format('YYYY-MM-DD'),
        // },
        // selectAllow: (info) => {
        //   let start = moment().startOf('month')
        //   let end = moment().endOf('month')
        //   if(moment(info.start).unix() > start.unix() || moment(info.end).unix() < end.unix()) {
        //     return true
        //   }
        //   return false
        // },
        // eventConstraint: {
        //     start: moment().startOf('month').format('YYYY-MM-DD'),
        //     end: moment().endOf('month').format('YYYY-MM-DD'),
        // },
        eventClick: (info) => {
          this.$emit('onCalendarEventClick', info.event.extendedProps.book)
        },
        dateClick: (info) => {
          let start = moment().startOf('month')
          let end = moment().endOf('month')
          let temp = moment(info.date)
          if (temp.unix() > start.unix() && temp.unix() < end.unix()) {
            let staffID
            if (info.resource && info.resource._resource && info.resource._resource.id) {
              staffID = info.resource._resource.id
            }
            this.$emit('onCalendarDateClick', info.date, staffID)
          }
          return
        },
        datesSet: (info) => {
          this.type = this.$refs.fullCalendar.getApi().view.type

          if (this.type === 'resourceTimeGridDay') {
            this.calendarOptions.dayMinWidth = 340
          } else {
            this.calendarOptions.dayMinWidth = 170
          }

          this.calendarOptions.events = []
          this.$emit('onCalendarDateChange', info)
        },
        resources: [],
      },
    };
  },
  watch: {
    apptHours(val) {
      this.blockDayGridHour()
    },
  },
  methods: {
    async getStaffList() {
      let st = await this.$store.state.staffs;
      this.staffs = JSON.parse(st);
      this.staffs = this.staffs.filter(s => s.showOnline === 1 && s.showAppt === 1 && s.enable === 1);
      this.staffsClone = JSON.parse(st);
    },

    setDate(start, end) {
      // start = moment(start)
      // end = moment(end)
      // if(this.$refs.fullCalendar.getApi().view.type === 'dayGridMonth') {
      //   start = start.startOf('week')
      //   end = end.endOf('week')
      // }

      this.$refs.fullCalendar.getApi().gotoDate(start)
    },
    async setAppointmentList(result) {
      this.blockDayGridHour()

      await new Promise(resolve => setTimeout(resolve, 100))

      let staffMap = {}
      this.calendarOptions.resources = []
      this.staffs.forEach(staff => {
        if (this.selectedOutlet && this.selectedOutlet.id) {
          if (staff.outletID !== this.selectedOutlet.id) {
            return
          }

          this.calendarOptions.resources.push({
            id: staff['staffID'],
            title: staff['name'],
          })

          staffMap[staff['staffID']] = true
        }
      })

      this.calendarOptions.events = []
      result.forEach(book => {
        if (!staffMap[book['staffID']]) {
          return
        }

        let color = 'bg-primary'
        if (book.completedDate) {
          color = 'bg-success'
        } else if (book.noshowDate) {
          color = 'bg-danger'
        }

        let start = moment(book.arrivalDate)
        let end = moment(start).add(book.duration, 'minutes')

        book.text = ''
        if (this.$refs.fullCalendar.getApi().view.type === 'resourceTimeGridDay') {
          book.text = book.member
        } else {
          if (this.selectedStaff && this.selectedStaff.staffID) {
            book.text = book.member
          } else {
            book.text = book.staff
          }
        }

        this.calendarOptions.events.push({
          title: `${start.format('HH:mm A')} - ${end.format('HH:mm A')}`,
          book: book,
          cellClass: color,
          resourceId: book['staffID'],
          classNames: "calendarEvents",
          start: moment(start).format(this.$refs.fullCalendar.getApi().view.type === 'resourceTimeGridDay' ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'),
          end: moment(end).format(this.$refs.fullCalendar.getApi().view.type === 'resourceTimeGridDay' ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'),
        });
      })

      this.$nextTick(() => {
        this.blockDayGridHour()
      })
      // this.blockDayGridHour()
    },

    blockDayGridHour() {
      let apptHourSet = false
      for (let hour of this.apptHours) {
        if (hour['appt']) {
          apptHourSet = true
          break
        }
      }

      if (!apptHourSet) {
        return
      }

      let start = -1
      let end = 99
      for (let hour of this.apptHours) {
        if (hour['appt']) {
          if (start === -1 || hour['hourID'] < start) {
            start = hour['hourID']
          }
          if (end === 99 || hour['hourID'] > end) {
            end = hour['hourID']
          }

          let temp
          temp = jQuery('.fc-timegrid-slots tr:eq(' + (hour['hourID'] * 2) + ')')
          if (temp && temp[0]) {
            jQuery(temp[0]).show()
          }
          temp = jQuery('.fc-timegrid-slots tr:eq(' + (hour['hourID'] * 2 + 1) + ')')
          if (temp && temp[0]) {
            jQuery(temp[0]).show()
          }
          temp = jQuery('.fc-timegrid-axis-chunk tr:eq(' + (hour['hourID'] * 2) + ')')
          if (temp && temp[0]) {
            jQuery(temp[0]).show()
          }
          temp = jQuery('.fc-timegrid-axis-chunk tr:eq(' + (hour['hourID'] * 2 + 1) + ')')
          if (temp && temp[0]) {
            jQuery(temp[0]).show()
          }
        } else {
          let temp
          temp = jQuery('.fc-timegrid-slots tr:eq(' + (hour['hourID'] * 2) + ')')
          if (temp && temp[0]) {
            jQuery(temp[0]).hide()
          }
          temp = jQuery('.fc-timegrid-slots tr:eq(' + (hour['hourID'] * 2 + 1) + ')')
          if (temp && temp[0]) {
            jQuery(temp[0]).hide()
          }
          temp = jQuery('.fc-timegrid-axis-chunk tr:eq(' + (hour['hourID'] * 2) + ')')
          if (temp && temp[0]) {
            jQuery(temp[0]).hide()
          }
          temp = jQuery('.fc-timegrid-axis-chunk tr:eq(' + (hour['hourID'] * 2 + 1) + ')')
          if (temp && temp[0]) {
            jQuery(temp[0]).hide()
          }
        }
      }

      // this.calendarOptions.businessHours = [{daysOfWeek: [ 0, 1, 2, 3, 4, 5, 6, 7 ]}]
      // this.calendarOptions.businessHours[0]['startTime'] = moment().set(start, 'hour').format('HH:mm')
      // this.calendarOptions.businessHours[0]['endTime'] = moment().set(end, 'hour').format('HH:mm')

      // setTimeout(() => {
      //   this.$refs.fullCalendar.getApi().updateSize()
      //   // this.$refs.fullCalendar.getApi().render()
      // }, 500)
    },
  },
  mounted() {
    // this.setAppointmentList();
    this.getStaffList()
  },
};
</script>

<style>
.wrap {
  display: flex;
}

.left {
  margin-right: 10px;
}

.content {
  flex-grow: 1;
}

.fc .fc-timegrid-slot {
  height: 90px;
  border-bottom: 0;
}

.fc-v-event {
  background-color: #0000;
}
</style>
